import { render, staticRenderFns } from "./TimetableTrash.vue?vue&type=template&id=0b1636c3"
import script from "./TimetableTrash.vue?vue&type=script&lang=js"
export * from "./TimetableTrash.vue?vue&type=script&lang=js"
import style0 from "./TimetableTrash.vue?vue&type=style&index=0&id=0b1636c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports